<template>













	<!--
		
		1. Consider just including this into the template of NodeContainer!!!
			We don't need a path to login, because if a user wants to swtich the session, he just unsets the active session FOR THIS NODE.
				IMPORTANT: This means that we need to track active sessions PER NODE, not globally. See /store/modules/authentication.js...
					.. And rename it to sessions.js :)
		
		2. We need a way to track "Which session was last chosen (or logged in) for this node?"
			So that, when a user comes back, he doesn't have to re-choose... but he CAN SWITCH the session.

		3. For now, we'll just show the sessions OF THIS NODE.
			In the future, when nodes allow other nodes' sessions, we'll have to elaborate

	-->








	<div class="container-fluid">
		<div class="row">
			<div class="col">
				<div class="card shadow-sm">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Node Login ({{nodeId}})</h4>
					</div>
					<div class="card-body">
						<form v-if="!loggedIn" v-on:submit.prevent="login">
							<div class="form-row form-group">
								<div class="col-auto">
									<input type="text" class="form-control" autocomplete="username" placeholder="username" v-model="username">
								</div>
								<div class="col-auto">
									<input type="password" class="form-control" autocomplete="current-password" placeholder="password" v-model="password">
								</div>
								<button class="btn btn-primary ml-1" type="submit">Login</button>
							</div>
						</form>
						<form v-if="loggedIn" v-on:submit.prevent="logout">
							You are logged in! Here is your session info:
							<pre style="text-align: left; border: 1px solid #999;">{{sessionData}}</pre>
							<button class="btn btn-danger" type="submit">Logout</button>
						</form>
					</div>
				</div>
				<br>
				<div class="card shadow-sm" v-if="sessionLookupByNode[nodeId] && Object.keys( sessionLookupByNode[nodeId] ).length > 0">
					<div class="card-header">
						<h4 class="my-0 font-weight-normal">Existing Sessions</h4>
					</div>
					<div class="card-body">
						If you have any existing sessions <u>for this node</u>, you may select them here. Initially, you may only use sessions for the same node,
						but this will be expanded shortly, to allow cross-node sessions:
						<p style="margin-top: 10px;">
							<!-- <h4>{{nodeId}}</h4> -->
							<ul>
								<li v-for="session in sessionLookupByNode[nodeId]" :key="session.$id">
									<a href="javascript:void(0)" @click.prevent="activateSession( nodeId+'/'+session.$id )">{{session.account}} ({{session.$id}})</a>
								</li>
							</ul>
						</p>


						<!-- TEMP: Remove other nodes' sessions.. these can be re-added when support is added on the backend, etc. -->
						<!-- <p v-for="( sessions, thisNodeId ) in sessionLookupByNode" v-if="thisNodeId != nodeId" :key="thisNodeId">
							<h4>{{thisNodeId}}</h4>
							<ul>
								<li v-for="session in sessions" :key="session.$id">
									<a href="javascript:void(0)" @click.prevent="activateSession( thisNodeId+'/'+session.$id )">{{session.account}} ({{session.$id}})</a>
								</li>
							</ul>
						</p> -->
					</div>
				</div>
			</div>
		</div>
	</div>

</template>

<script>


// SEE: https://scotch.io/tutorials/handling-authentication-in-vue-using-vuex



import { mapState, mapGetters, mapActions, mapMutations } from "vuex";

export default {
	name: "node-login",
	props : [ 'nodeId' ],
	data() {
		return {
			username: "",
			password: "",
		};
	},
	computed: {
		loggedIn : function( ) {
			return !!this.currentSession;
		},
		currentSession : function( )
		{
			try {
				return this.session( this.activeSession( this.nodeId ) );
			} catch( err ) {
				return null;
			}
		},
		sessionData : function( ) {
			if( this.currentSession )
				return JSON.stringify( this.currentSession, null, 2 );
			return "{}";
		},
		...mapGetters( "authentication", [
			"sessionLookupByNode",
			"activeSession",
			"session"
		]),
	},
	methods:
	{
		activateSession: async function( sessionGuid )
		{
			try {
				if( await this.$store.dispatch( 'authentication/checkSession', { nodeId : this.nodeId, sessionKey : sessionGuid } ) )
					this.$store.commit( 'authentication/setActiveSession', { nodeId : this.nodeId, sessionGuid } );
				else
				{
					console.warn( "Session activation failed! Session probably expired..." );
					alert( "Session activation failed!\n\nSession probably expired..." );
				}
			} catch( err ) { console.error( err ); alert( "Session Activation failed!\n\n"+ err.message +"\n\nNOTE: Cross node logins are not yet supported!" ); }
		},
		login : async function( )
		{
			if( !this.username || !this.password )
				return alert( "[Authentication] Must provide a username (or account ID) AND password!" );
			
			try {
				console.log( "NODE ID:", this.nodeId );
				
				let loginNode = this.nodeId;	// This may be another node in the future!

				let newSession = await this.$store.dispatch( 'authentication/login', { nodeId : loginNode, username : this.username, password : this.password } );
				if( newSession )
				{
					let sessionGuid = loginNode +"/"+ newSession.$id;	// Session GUID WRT the logged in node, not necessarily the current node (future)
					this.$store.commit( 'authentication/setActiveSession', { nodeId : this.nodeId, sessionGuid } );
					console.log( "LOGGED IN!", this.loggedIn );
				}
				else
					alert( "Login failed!!" );
				
			} catch( err ) {
				console.error( "[Authentication] Technical login error:", err );
			}
		},
		...mapActions({
			//login: "authentication/login",
			logout: "authentication/logout",
			listProjects: "projects/list",
		})
	},
	mounted()
	{
		//console.log( "[Authentication] PARAMS:", this.$route.params );
	},
	created( )
	{
		console.log( "[Authentication] CREATED ("+ this.nodeId +")" );
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/NodeLogin.vue